import { Box, Typography } from '@mui/material';
import { FeatureIcon } from './feature-icon';

export interface EmptyListProps {
  /** Plain icon element — it is wrapped in a `FeatureIcon` badge here. */
  icon: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode;
  action?: React.ReactNode;
  /**
   * Compact variant for the summary sidebars: smaller title, description and
   * icon badge, centred without the extra page padding.
   */
  compact?: boolean;
}

export const EmptyList = ({
  icon,
  title,
  description,
  action,
  compact = false,
}: EmptyListProps) => {
  return (
    <Box
      sx={{
        ...(compact ? {} : { pt: 8, pb: 8, mb: 5 }),
        textAlign: 'center',
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'center',
      }}
    >
      <Box sx={{ mb: 3 }}>
        <FeatureIcon
          icon={icon}
          color="primary"
          disabled={true}
          size={compact ? 'medium' : 'large'}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 0.5,
          ...(compact ? { maxWidth: 300 } : {}),
        }}
      >
        <Typography variant={compact ? 'h6' : 'h5'}>{title}</Typography>
        <Typography
          variant={'body2'}
          sx={{
            color: 'text.secondary',
          }}
        >
          {description}
        </Typography>
      </Box>
      {action && (
        <Box
          sx={{
            mt: 4,
          }}
        >
          {action}
        </Box>
      )}
    </Box>
  );
};
